import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputPhone } from 'common/components';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import ButtonSection from 'features/feature-admin-profile/components/ButtonSection';
import { DividerStyled, Wrapper } from './styles';
import ChangePhoneModal from '../ChangePhoneModal';
import { adminVerifyPhone } from 'applicaiton/store/reducers/Admins/ActionCreators';
import { usePhoneForm } from 'features/feature-admin-profile/hooks/usePhoneForm';
import { UserType } from '@docbay/schemas/dist/user/user.types';
import PhoneChangedPopUp from '../PhoneChangedPopUp';
import { resetPhoneData } from 'applicaiton/store/reducers/Admins/AdminsSlice';

const Phone: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { currentUser, isVerifiedOldPhone, error } = useAppSelector(
    (state) => state.admins,
  );
  const [showPhonePopUp, setShowPhonePopUp] = useState(false);
  const [isPhoneExist, setIsPhoneExist] = useState(false);
  const attemptLimitExceeded = error.endsWith('500');
  const { register, errors, handleSubmit, watch, setValue } = usePhoneForm({
    requiredError: t('errors.required'),
  });

  useEffect(() => {
    setValue('phone', currentUser?.phone || '');
  }, [currentUser]);

  const handleCloseModal = () => {
    isPhoneExist && setIsPhoneExist(false);
    setShowPhonePopUp(false);
  };

  const handleClosePhoneChangeModal = () => {
    setValue('phone', currentUser?.phone || '');
    dispatch(resetPhoneData());
  };

  const handleOpenForm = async () => {
    sessionStorage.setItem('newPhone', `+${watch('phone')}`);
    sessionStorage.setItem('oldPhone', String(currentUser?.phone));
    setShowPhonePopUp(false);

    dispatch(
      adminVerifyPhone({
        phone: String(currentUser?.phone),
        userType: UserType.Admin,
      }),
    );
  };

  const onSubmit = () => {
    setShowPhonePopUp(true);
  };

  return (
    <Wrapper onSubmit={handleSubmit(onSubmit)}>
      <div>
        <InputPhone
          id="phone"
          label={t('phone') || ''}
          register={register}
          errorMessage={
            attemptLimitExceeded
              ? t('error_attempt_limit') || ''
              : errors.phone?.message
          }
          value={watch('phone')}
          isValid={true}
        />
      </div>
      <div>
        <DividerStyled />
        <ButtonSection
          disabled={
            !!Object.keys(errors).length ||
            watch('phone') === currentUser?.phone
          }
        />
      </div>
      {showPhonePopUp && (
        <PhoneChangedPopUp
          onClose={handleCloseModal}
          onSubmit={handleOpenForm}
        />
      )}
      {isVerifiedOldPhone && (
        <ChangePhoneModal
          isOpen={isVerifiedOldPhone}
          onClose={handleClosePhoneChangeModal}
        />
      )}
    </Wrapper>
  );
};

export default Phone;
